export const SET_CURRENCIES = "main/setCurrencies";
export const SET_MAX_PAGE = "main/setMaxPage";
export const SET_HISTORY = "main/setHistory";
export const SET_TOP_CURRENCIES = "portfolio/setTopCurrencies";
export const REMOVE_CURRENCY = "portfolio/removeCurrency";
export const ADD_CURRENCY = "portfolio/addCurrency";
export const UPDATE_CURRENCY = "portfolio/updateCurrency";
